// @ts-nocheck
import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
// import { Popup, SliderComponent } from "./components";
import TheBanner from "layout/TheBanner/TheBanner";
import Select from "react-select";
import { handleScroll, isTokenExpired, urlAssetsCustom } from "utils/common";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TheHeader from "layout/TheHeader";
import TheFooter from "layout/TheFooter";
import { UploadFile } from "utils/uploadBlob";
import imageCompression from "browser-image-compression";
import { useDispatch } from "react-redux";
import actions from "redux/home/actions";
import { useForm } from "react-hook-form";
import {
  browserSessionPersistence,
  getAuth,
  onAuthStateChanged,
  onIdTokenChanged,
  setPersistence,
  signInWithCredential,
  signInWithCustomToken,
  signInWithRedirect,
  signOut,
} from "firebase/auth";
import PopupCard from "components/popup-card";
import html2canvas from "html2canvas";
// import * as styles from "./styles.module.scss";
// import {bgs, than,btn1, btn2, btn3 } from "assets/img"
const CardPageView = (props) => {
  const {
    addDisableBtn,
    removeDisableBtn,
    setIsLoading,
    checkError,
    setIsLoadingUpload,
  } = props;
  const [fileError, setFileError] = useState();
  const [fileUrl, setFileUrl] = useState(null);
  const [removeBGImg, setRemoveBGImg] = useState(null);
  const [fullNameErr, setFullNameErr] = useState();
  const [noteErr, setNoteErr] = useState();
  const dispatch = useDispatch();
  const auth = getAuth();
  const [modalCard, setModalCard] = useState(false);
  const [contentCard, setContentCard] = useState();
  const [ImageFilePreview, setImageFilePreview] = useState();
  const hideModal = () => {
    setModalCard(false);

    document.body.classList.remove("modal-open");
  };
  const showModalCard = () => {
    setModalCard(true);
    document.body.classList.add("modal-open");
  };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm();
  const navigate = useNavigate();
  const optionsCompress = {
    maxSizeMB: 1,
    useWebWorker: true,
  };
  const isExpired = isTokenExpired(localStorage.getItem("accessToken"));
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/");
    }
  }, [localStorage.getItem("accessToken")]);
  console.log("isExpired", isExpired);
  const senderInfo = JSON.parse(localStorage.getItem("cardSenderInfo"));
  const handleDetectImg = (url) => {
    dispatch(
      actions.DETECT_IMAGE.request(
        { imageUrl: url },
        (res) => {
          setIsLoadingUpload(false);
          if (!res?.sensitive_result?.is_valid) {
            setFileError(
              "Ảnh của bạn không phù hợp với thuần phong mỹ tục Việt Nam. Vui lòng chọn một bức ảnh khác phù hợp hơn và gửi lại nhé!"
            );
            return;
          } else {
            if (res?.human_detect_result?.human_count > 3) {
              setFileError(
                "Ảnh của bạn có quá nhiều người. Để có tấm thiệp đẹp nhất, vui lòng chọn một bức ảnh chỉ có tối đa ba người nhé!"
              );
              return;
            } else if (res?.human_detect_result?.human_count === 0) {
              setFileError(
                "Chúng tôi không thể nhận diện được người trong ảnh của bạn. Vui lòng chọn một bức ảnh khác rõ ràng hơn và gửi lại nhé!"
              );
              return;
            }
          }
          setRemoveBGImg(res?.image_removed_background_url);
          setFileUrl(url);
        },
        (err) => {
          if (err?.status === 401) {
            setIsLoading(false);
            setIsLoadingUpload(false);
            navigate("/");
          }
          checkError(err?.status);
          setIsLoading(false);
          setIsLoadingUpload(false);
        }
      )
    );
  };

  const handleDetectText = async (e) => {
    // await renewToken();

    setFullNameErr();
    setNoteErr();
    dispatch(
      actions.DETECT_TEXT.request(
        { text: [watch("fullName"), watch("note")] },
        (res) => {
          if (res?.[0] === 1) {
            handleScroll("step2");
            setFullNameErr(
              "Vui lòng kiểm tra lại tên người nhận nhé. Có vẻ như bạn đã nhập sai thông tin"
            );
          }
          if (res?.[1] === 1) {
            handleScroll("step2");
            setNoteErr(
              "Lời chúc của bạn chứa từ ngữ không phù hợp với thuần phong mỹ tục Việt Nam. Vui lòng chỉnh sửa lại lời chúc với ngôn từ phù hợp hơn nhé!"
            );
          }
          if (res?.[0] === 0 && res?.[1] === 0) {
            handleCreateCard();
          }
        },
        (err) => {
          if (err?.status === 401) {
            navigate("/");
          }
          checkError(err?.data?.error?.errorCode);
        }
      )
    );
  };
  const handleCreateCard = async () => {
    // await renewToken();

    dispatch(
      actions.CREATE_CARD.request(
        {
          RawImageUrl: fileUrl,
          ProcessedImageUrl: removeBGImg,
          ReceiverName: watch("fullName"),
          Content: watch("note"),
          IsConsent: watch("isAgree"),
          Otp: senderInfo?.otp,
          SenderName: senderInfo?.name,
        },
        (res) => {
          setContentCard({
            imageUrl: ImageFilePreview,
            receiverName: watch("fullName"),
            content: watch("note"),
          });
          showModalCard();
        },
        (err) => {
          if (err?.status === 401) {
            navigate("/");
          }
          checkError(err?.data?.ErrorCode);
        }
      )
    );
  };
  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // await renewToken();
    setFileError();
    setFileUrl();
    setRemoveBGImg();
    setIsLoadingUpload(false);
    console.log("file", file);
    if (file.size / 1024 < 50) {
      setFileError(
        "Ảnh mờ: Ảnh của bạn bị mờ và không rõ nét. Vui lòng chọn một bức ảnh khác rõ nét hơn và gửi lại nhé!"
      );
    } else {
      try {
        setIsLoadingUpload(true);
        let blobsInContainer = await UploadFile(e?.target.files[0]);

        handleDetectImg(blobsInContainer);
      } catch (err) {
        setIsLoadingUpload(false);
        console.error("uploadFail", err);
      }
    }
  };
  useEffect(() => {
    const intervalRenewToken = setInterval(() => {
      onIdTokenChanged(auth, async (user) => {
        // debugger;
        if (user) {
          console.log("user", user);
          const token = await user.getIdToken(true); //
          localStorage.setItem("accessToken", token);
        } else {
          // window.location.reload();

          signOut(auth); // Sign out if refresh fails
          navigate("/");
        }
      });
    }, 15 * 1000 * 60);
    return () => {
      clearInterval(intervalRenewToken);
    };
  }, []);

  useEffect(() => {
    reset();
    addDisableBtn("#btn-register");
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      console.log("value, { name, type }", value, name, type);
      if (
        value.fullName?.trim()?.length &&
        value.note?.trim()?.length &&
        !fileError &&
        removeBGImg
      ) {
        removeDisableBtn("#btn-register");
      } else {
        addDisableBtn("#btn-register");
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, fileError, removeBGImg]);

  useEffect(() => {
    if (fileError || !removeBGImg) {
      addDisableBtn("#btn-register");
    } else {
      removeDisableBtn("#btn-register");
    }
  }, [fileError, removeBGImg]);

  const fetchImage = async (imgUrl) => {
    try {
      const response = await fetch(imgUrl);
      const blob = await response.blob(); // Convert response to Blob
      const file = new File([blob], "downloaded-image.jpg", {
        type: blob.type,
      }); // Convert to File
      const imageObjectUrl = URL.createObjectURL(file); // Create local URL
      setImageFilePreview(imageObjectUrl);
    } catch (error) {
      console.error("Error fetching image:", error);
    }
  };
  useEffect(() => {
    removeBGImg && fetchImage(removeBGImg);
  }, [removeBGImg]);

  return (
    <section>
      <TheHeader
        navMenu={true}
        // namePage={`Trang Chủ`}
        // actionPage={`/home-page`}
      />
      <div className="main-inner card-create">
        <img className="d-none" src={urlAssetsCustom("assets/img/KV.png")} />
        <form
          className="register-form"
          onSubmit={handleSubmit(handleDetectText)}
        >
          <div className="container">
            <img
              className="Tittle-create-card"
              src={urlAssetsCustom("assets/img/Tittle-create-card.png")}
            />
            <div className="formcard-inner">
              <img
                className="step1 d-none-mb"
                src={urlAssetsCustom("assets/img/Title-bar-1.png")}
              />
              <img
                className="step1 d-none"
                src={urlAssetsCustom("assets/img/Title-bar-1-mb.png")}
              />
              <div className="step-content">
                <div className="form-group">
                  <p className="text-form">
                    Hãy gửi tấm ảnh mẹ bạn cười thật tươi vào đây nhé!{" "}
                    <span>*</span>
                  </p>
                  {fileUrl && (
                    <div>
                      <img
                        style={{
                          maxHeight: 350,
                          display: "block",
                          margin: "0 auto 20px auto",
                        }}
                        src={fileUrl}
                        alt=""
                      />
                    </div>
                  )}

                  <div className="form-field">
                    <div className={`boxQRcode ${fileError && "error"}`}>
                      <div>
                        <p className="note-boxQRcode">
                          Tải ảnh của bạn lên từ thiết bị
                        </p>

                        <div style={{ position: "relative" }}>
                          <button
                            type="button"
                            className="btn btn-upload btn-block btn-qrcode"
                          >
                            <a>
                              <span className="i-upload"></span> Tải lên...
                            </a>
                          </button>
                          <input
                            style={{
                              position: "absolute",
                              zIndex: 99,
                              left: 0,
                              top: 0,
                              opacity: 0,
                              width: "100%",
                              height: "100%",
                            }}
                            type="file"
                            accept="image/png, image/jpg, image/jpeg, image/heif, image/heic"
                            onChange={(e) => handleUpload(e)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {fileError && <p className="text-error">{fileError}</p>}
                </div>
              </div>
              <img
                id="step2"
                className="step1 d-none-mb"
                src={urlAssetsCustom("assets/img/Title-bar-2.png")}
              />
              <img
                id="step2"
                className="step1 d-none"
                src={urlAssetsCustom("assets/img/Title-bar-2-mb.png")}
              />
              <div className="step-content">
                <div className="form-group">
                  {/* <p className="text-form">
                    Hãy gửi tấm ảnh mẹ bạn cười thật tươi vào đây nhé!
                  </p> */}
                  <label className="title-form" htmlFor="usr">
                    Tên người nhận thiệp <span>*</span>
                  </label>
                  <div className="form-field">
                    {/* <img
                    src={urlAssetsCustom("assets/img/icon/close-modal.png")}
                    alt="text-info "
                    className="clear-icon"
                    onClick={() => props?.clearFieldFormData("fullName")}
                  /> */}
                    <input
                      type="text"
                      // disabled={commingSoon || campainEnd}
                      className={`form-control ${fullNameErr && "errors"}`}
                      // onChange={(e) => {
                      //   fullnameRef.current.value = e.target.value.replace(/[!-_|=@#$%^~`()&*]/g, "");
                      // }}
                      id="usr"
                      {...register("fullName")}
                      name="fullName"
                      placeholder="Nhập họ và tên..."
                      maxlength="30"
                      min="0"
                      max="30"
                    />
                  </div>
                  {fullNameErr && (
                    <p className="text-error">
                      Vui lòng kiểm tra lại tên người nhận nhé. Có vẻ như bạn đã
                      nhập sai thông tin
                    </p>
                  )}
                </div>
              </div>
              <img
                className="step1 d-none-mb"
                src={urlAssetsCustom("assets/img/Title-bar-3.png")}
              />
              <img
                className="step1 d-none"
                src={urlAssetsCustom("assets/img/Title-bar-3-mb.png")}
              />

              <div className="step-content">
                <div className="form-group">
                  {" "}
                  <p className="text-form">Điền lời chúc của bạn vào đây</p>
                  <label className="title-form" htmlFor="usr">
                    Nội dung lời chúc <span>*</span>
                  </label>
                  <div className="form-field">
                    <textarea
                      id="note"
                      {...register("note")}
                      className={`form-control ${noteErr && "errors"}`}
                      name="note"
                      rows="20"
                      cols="50"
                      maxlength="300"
                    ></textarea>
                    <p className="textareacount">
                      {watch("note.length") > 0 ? watch("note.length") : "0"}
                      /300
                    </p>
                  </div>
                  {noteErr && (
                    <p className="text-error">
                      Lời chúc của bạn chứa từ ngữ không phù hợp với thuần phong
                      mỹ tục Việt Nam. Vui lòng chỉnh sửa lại lời chúc với ngôn
                      từ phù hợp hơn nhé!
                    </p>
                  )}
                </div>
              </div>
              <hr />
              <div className="step-content">
                <img
                  className="viewcard"
                  src={urlAssetsCustom("assets/img/viewcard.png")}
                />
                <div className="cardWrapper">
                  <div className="content-image">
                    <img
                      className="logoCard"
                      src={urlAssetsCustom("assets/img/logoCard.png")}
                    />
                    <div className="nameSend">
                      <h3>
                        <p>
                          Đến <span>{watch("fullName")}</span>
                        </p>
                      </h3>
                    </div>
                    <p
                      style={{ whiteSpace: "pre-line" }}
                      dangerouslySetInnerHTML={{ __html: watch("note") }}
                    ></p>
                    <img
                      className="spCard"
                      src={urlAssetsCustom("assets/img/sp.png")}
                    />
                  </div>
                  {!!ImageFilePreview && (
                    <div className="image-card">
                      <img src={ImageFilePreview} />
                    </div>
                  )}
                </div>
              </div>
              <div className="step-content" style={{ marginBottom: 0 }}>
                <div className={`group-checkbox `}>
                  <div className="checkbox-item">
                    <label htmlFor="isAgree">
                      <input
                        type="checkbox"
                        name="isAgree"
                        id="isAgree"
                        {...register("isAgree")}
                      />
                      <span className="checkmark"></span>
                      <p>
                        Cho phép P/S sử dụng hình ảnh và lời chúc của người dùng
                        để tạo thiệp chúc mừng và chia sẻ công khai trên website
                      </p>
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-wrapper text-center">
                <button
                  type="submit"
                  className="btn btn-primary btn-block"
                  id="btn-register"
                >
                  <a> Tạo thiệp</a>
                </button>
              </div>
              {/* <div>
                <button
                  onClick={() => {
                    setContentCard({
                      imageUrl: ImageFilePreview,
                      receiverName: watch("fullName"),
                      content: watch("note"),
                    });
                    showModalCard();
                  }}
                >
                  test
                </button>
              </div> */}
            </div>
          </div>
        </form>
        <img
          className="img-full bgfcard d-none-mb"
          src={urlAssetsCustom("assets/img/bgfcard.png")}
        />
        <img
          className="img-full bgfcard d-none"
          src={urlAssetsCustom("assets/img/bgfcard-mb.png")}
        />
      </div>
      {modalCard && (
        <PopupCard contentCard={contentCard} closeModalCard={hideModal} />
      )}
      <TheFooter />
    </section>
  );
};
export default CardPageView;
